module.exports = __webpack_public_path__ + "img/PEARLSAsset 212.1fc6543.svg";